// extracted by mini-css-extract-plugin
module.exports = {"wrongAnswerIcon":"WrongAnswerDialog_wrongAnswerIcon__1eb2e","wrongAnswerIconVisibled":"WrongAnswerDialog_wrongAnswerIconVisibled__3qemd"};